<template>
    <div class="FullObjectParam" v-if="value">
        <img class="FullObjectParam__img" :src="param.icon" alt="">
        <div class="FullObjectParam__about">
            <!--<div class="FullObjectParam__label">{{param.label}}</div>-->
            <div class="FullObjectParam__value">{{value}}</div>
        </div>
    </div>
</template>

<script>
import {getParamDescriptionByName} from '@/utils/getParamDescriptionByName'

export default {
    name: "FullObjectParam",
    props: {
        name: String,
        value: String
    },
    computed: {
        param() {
            return getParamDescriptionByName(this.name);
        }
    },
    methods: {
        getParamDescriptionByName
    }
}
</script>

<style lang="scss">
.FullObjectParam {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  text-align: center;

  &__about {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  &__img {
    margin-bottom: 12px;
  }

  &__label {
    margin-bottom: 4px;
    color: $gray;
  }

  &__value {
    font-size: 16px;
    font-weight: 500;
  }
}
</style>